import speak from 'speech-synthesis';

export function speaking(text) {
  speak(text, 'es-ES');
  //console.log("Speaking:", text);
}
